export default __webpack_public_path__ + "static/nextGenerationMechanicalPortable-dfb4d86a278629fac51f0ba038488743.png";